export default function Error() {
  return <>error</>;
}
